<template>
    <AppPage title="Confirmar pedido" subtitle="Por favor confirme os produtos do seu pedido"
             :check-user-permission="false">

        <b-button type="is-primary is-hidden-touch" rounded @click="saveOrder" slot="actions" v-if="totalCartPrice">
            Confirmar
        </b-button>

        <div class="store-product-list">
            <div class="product" v-for="product in products" :key="product.id">
                <storeProductAdd :product="product"/>
            </div>
        </div>

        <div class="mt-7" v-if="totalCartPrice">
            <b-field label="Observações">
                <b-input type="textarea" v-model="comment" :rows="3" placeholder="Observações sobre o pedido"/>
            </b-field>
        </div>

        <b-message type="is-warning" v-if="!totalCartPrice">Seu carrinho de pedidos está vazio, por favor
            <router-link :to="{name: 'home'}">adicione alguns produtos</router-link>
            ao carrinho para continuar.
        </b-message>

        <div class="card" slot="footer" v-if="totalCartPrice">
            <div class="card-content">
                <div class="columns is-mobile is-middle">
                    <div class="column">
                        <div class="is-small">Total (R$)</div>
                        <div class="is-size-3">{{ totalCartPrice | money('') }}</div>
                    </div>
                    <div class="column is-narrow">
                        <router-link class="button is-text" :to="{name: 'home'}" exact>Voltar</router-link>
                        <b-button type="is-primary" rounded @click="saveOrder">Confirmar</b-button>
                    </div>
                </div>
            </div>
        </div>

    </AppPage>
</template>

<script>
import * as Sentry from '@sentry/browser';
import {mapGetters} from "vuex";
import AppPage from "@/components/AppPage";
import storeProductAdd from "@/modules/cart/storeProductAdd";
import {create as createOrder} from '../modules/orders/orders.actions';

export default {
    name: "cartPage",
    components: {AppPage, storeProductAdd},

    data() {
        return {
            comment: null
        }
    },

    computed: {
        ...mapGetters(['productsInCart', "totalCartPrice", 'user']),
        products() {
            return this.productsInCart.map(cartProduct => {
                return {
                    id: cartProduct.id,
                    data: cartProduct.productData
                }
            });
        }
    },

    methods: {
        async saveOrder() {

            const loading = this.$buefy.loading.open();

            try {

                const products = this.productsInCart;
                const comment = this.comment;
                const order = await createOrder(products, comment);

                this.$store.commit('changeProductsInCart', []);

                await this.$router.push({
                    name: 'order.confirmed',
                    params: {orderNumber: order.data.order.number}
                });

            } catch (e) {
                console.error(e);
                Sentry.captureException(e);
                this.$buefy.dialog.alert({
                    title: 'Ops algo deu errado',
                    message: 'Ocorreu um erro ao salvar o seu pedido, por favor verifique sua conexão com a internet ou tente novamente mais tarde',
                    type: 'is-danger',
                    icon: 'times-circle',
                    confirmText: 'Ok'
                })
            }

            loading.close();

        }
    }
}
</script>